import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { SelectButton } from "primereact/selectbutton";
import { useState } from "react";
import {
  genElDate,
  genElDateObject,
  genElObject,
} from "../../../components/utils/EditorDialogElementGenerator";
import { format } from "date-fns";
import KendaraanSelectorDialog from "../../../dialogs/selectors/KendaraanSelectorDialog";
import { Dropdown } from "primereact/dropdown";

const filterModeOptions = [
  { icon: "pi pi-calendar", value: "By Tanggal" },
  { icon: "pi pi-truck", value: "By Kendaraan" },
];

const jenisKendaraanOptions = [
  { name: "Dutro", id: 1 },
  { name: "Mobil", id: 2 },
  { name: "Trado", id: 17 },
];

const PengisianMinyakFilter = (props) => {
  const { filterValue, setFilterValue, onClickRefresh } = props;

  const [showKendaraanSelector, setShowKendaraanSelector] = useState(false);

  // handle ui event section
  const handleOnConfirmKendaraan = (event, datas) => {
    if (datas && datas.length > 0) {
      const kendaraan = datas[0];
      setFilterValue((prevData) => ({
        ...prevData,
        data_kendaraan: kendaraan,
        kendaraan_id: kendaraan.id,
      }));
      setShowKendaraanSelector(false);
    }
  };

  // custom ui section

  const elTanggalDari = genElDateObject({
    field: "tanggal_dari",
    name: "Tanggal Dari",
    value: filterValue.tanggal_dari,
    data: filterValue,
    setData: setFilterValue,
    primeFormat: "dd M yy",
  });

  const elTanggalSampai = genElDateObject({
    field: "tanggal_sampai",
    name: "Tanggal Sampai",
    value: filterValue.tanggal_sampai,
    data: filterValue,
    setData: setFilterValue,
    primeFormat: "dd M yy",
  });

  const elNomorPolisi = genElObject({
    field: "kendaraan_id",
    name: "No Polisi",
    value: filterValue.data_kendaraan
      ? filterValue.data_kendaraan.nomor_polisi
      : "",
    onClick: () => {
      setShowKendaraanSelector(true);
    },
    onClear: () => {
      setFilterValue((prevData) => ({
        ...prevData,
        kendaraan_id: null,
        data_kendaraan: null,
      }));
    },
  });

  return (
    <div className="row-between-end gap-4 w-full flex-wrap">
      <KendaraanSelectorDialog
        title={"Pilih Kendaraan"}
        visible={showKendaraanSelector}
        onHide={() => setShowKendaraanSelector(false)}
        onConfirm={handleOnConfirmKendaraan}
      />

      {/* filter component section */}
      <div className="flex flex-col sm:flex-row justify-between items-end sm:items-start sm:gap-4 w-full">
        <div className="row-start-end gap-4 w-full sm:w-auto flex-wrap">
          <div className="col-start-start gap-1 w-full sm:w-auto">
            <span className="text-sm font-bold text-slate-500">
              Jenis Kendaraan
            </span>
            <Dropdown
              className="w-full md:w-14rem"
              value={filterValue.jenis_kendaraan}
              onChange={(e) =>
                setFilterValue({ ...filterValue, jenis_kendaraan: e.value })
              }
              options={jenisKendaraanOptions}
              optionLabel="name"
              placeholder="Pilih Jenis"
            />
          </div>

          <div className="flex flex-col sm:flex-row justify-start w-full sm:w-auto items-start gap-4">
            {/* filter tanggal */}
            <div className="row-start-start w-full sm:w-[12rem]">
              {elTanggalDari}
            </div>
            <div className="row-start-start w-full sm:w-[12rem]">
              {elTanggalSampai}
            </div>
          </div>

          <div className="row-center-center w-full sm:w-[15rem]">
            {elNomorPolisi}
          </div>
        </div>
        <div className="col-start-center pt-4">
          <Button
            icon="pi pi-refresh"
            outlined
            rounded
            onClick={() => {
              if (onClickRefresh) onClickRefresh();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default PengisianMinyakFilter;
